import { render, staticRenderFns } from "./EmployeeFolderAdd.vue?vue&type=template&id=4f03568f&"
import script from "./EmployeeFolderAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeFolderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports